import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { FiEye, FiEyeOff, FiMail, FiLock } from "react-icons/fi";
import { loginUser } from "../services/authService";
import "./SignInLayer.css";

// Simplified Schema: Only Email and Password
const schema = yup.object().shape({
  email: yup.string().email("Please enter a valid email").required("Email is required"),
  password: yup.string().required("Password is required"),
});

const SignInLayer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // API call with email and password only
      const res = await loginUser(data.email, data.password);

      if (res?.status === "Active" || res?.success) {
        localStorage.setItem("token", res.token);
        toast.success("Welcome back! Login successful.");
        navigate("/");
      } else {
        toast.error(res?.message || "Invalid credentials provided.");
      }
    } catch (err) {
      toast.error("Unable to connect. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        {/* LEFT DECORATIVE SIDE */}
        <div className="auth-left">
          <div className="left-content">
            <h5>Welcome <br /> Back</h5>
            <p>Access your dashboard to manage your school efficiently.</p>
          </div>
        </div>

        {/* RIGHT FORM SIDE */}
        <div className="auth-right">
          <div className="auth-header">
            <h3>Sign In</h3>
            <p className="auth-subtitle">Login with your registered email</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            
            {/* Email Field */}
            <div className="input-group">
              <label>Email Address</label>
              <div className="input-container">
                <span className="input-icon"><FiMail size={18} /></span>
                <input
                  type="email"
                  placeholder="admin@school.com"
                  className={`premium-input ${errors.email ? "error-border" : ""}`}
                  {...register("email")}
                />
              </div>
              {errors.email && <p className="error-text">{errors.email.message}</p>}
            </div>

            {/* Password Field */}
            <div className="input-group">
              <label>Password</label>
              <div className="input-container">
                <span className="input-icon"><FiLock size={18} /></span>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className={`premium-input ${errors.password ? "error-border" : ""}`}
                  {...register("password")}
                />
                <span 
                  className="password-toggle" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </span>
              </div>
              {errors.password && <p className="error-text">{errors.password.message}</p>}
            </div>

            <div className="form-options">
              {/* <label className="remember-me">
                <input type="checkbox" /> 
                <span>Remember me</span>
              </label> */}
              <Link to="/forgot-password" alt="Forgot password" className="forgot-link">
                Forgot password?
              </Link>
            </div>

            <button type="submit" className="signin-btn text-center" disabled={loading}>
              {loading ? "Please wait..." : "Sign In"}
            </button>

            <div className="auth-footer">
              Don't have an account?{" "}
              <Link to="/sign-up" className="signup-link">Sign Up</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignInLayer;